import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { Form as FormikForm, Formik } from 'formik';

import {
  ClientDisclosureFragment,
  ClientDisclosureStatus,
  UpdateClientDisclosureInput,
  useUpdateClientDisclosureMutation,
} from 'api';
import { ValidatedSwitch, ValidatedTextFieldNext } from 'components';
import { useNotify } from 'hooks';
import { DisclosuresSchema } from 'features/admin/validations';
import { useUpdateDisclosure } from 'features/admin/updaters';

interface IProps {
  disclosure: ClientDisclosureFragment;
}

const Update: FC<IProps> = ({ disclosure }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const mutationOptions = useUpdateDisclosure({ data: {} });
  const { mutate: updateClientDisclosureMutation } = useUpdateClientDisclosureMutation({
    onSuccess: () => notify.info({ message: t('admin:disclosureUpdateNotification') }),
    ...mutationOptions,
  });

  function checkStatus(value: ClientDisclosureStatus) {
    return value === ClientDisclosureStatus.Active;
  }

  function getNextStatus(value: ClientDisclosureStatus) {
    return value === ClientDisclosureStatus.Active
      ? ClientDisclosureStatus.Disabled
      : ClientDisclosureStatus.Active;
  }

  function handleSubmit(values: UpdateClientDisclosureInput) {
    return updateClientDisclosureMutation({ data: values });
  }

  return (
    <Formik initialValues={disclosure} onSubmit={handleSubmit} validationSchema={DisclosuresSchema}>
      {({ submitForm, setFieldValue, values }) => (
        <FormikForm>
          <Grid container marginBottom={2}>
            <Grid xs={3} />
            <Grid xs={7} container alignItems="center">
              <Grid xs={11}>
                <ValidatedTextFieldNext
                  name="disclosure"
                  placeholder={t('admin:addDisclosure')}
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid xs={1} />
            </Grid>
            <Grid xs={2} container alignItems="center" justifyContent="center">
              <ValidatedSwitch
                name="disclosure_status"
                checkedFn={checkStatus}
                onChange={() => {
                  setFieldValue('disclosure_status', getNextStatus(values.disclosure_status));
                  void submitForm();
                }}
                color="primary"
              />
            </Grid>
          </Grid>
        </FormikForm>
      )}
    </Formik>
  );
};

export default Update;
